import { useMutation } from '@tanstack/react-query';
import {
  uploadProductImage,
  readBarcode,
  deleteProductImage,
} from 'services/product';

export const useUploadProductImage = (options = {}) => {
  return useMutation({
    mutationFn: (file) => {
      const formData = new FormData();

      formData.append('File', file);

      // Append DetectBarcode if needed (default to false)
      formData.append('DetectBarcode', options.detectBarcode || false);

      formData.append('MemberId', options.memberId || null);

      return uploadProductImage(formData);
    },

    ...options,
  });
};

export const useDeleteProductImage = (options = {}) => {
  return useMutation({
    mutationFn: (imageId) => {
      return deleteProductImage({ imageId });
    },
    ...options,
  });
};

export const useReadBarcodeImage = (options = {}) => {
  return useMutation({
    mutationFn: (file) => {
      const formData = new FormData();

      formData.append('File', file);

      return readBarcode(formData);
    },

    ...options,
  });
};
